import types from '../types'
import api from '../../api'
import Client from '../../utils/socket'
import router from '../../router'
import Vue from 'vue'

const state = {
  fabulous: 0,
  applause: 0,
  imConfig: {},
  msgUrl: '',
  wsConnectStatus: '',
  wsStatue: false,
  wsLoading: false,
  newTips: {},
  removeMessageKey: '',
  chatMessage: {},
  giftMessage: {},
  socketLiveAd: {},
  hasTips: false,
  questionParams: {},
  protonAwardsMsg: {}
}

const getters = {
  fabulous: state => state.fabulous,
  applause: state => state.applause,
  wsStatue: state => state.wsStatue,
  hasTips: state => state.hasTips,
  wsLoading: state => state.wsLoading,
  questionParams: state => state.questionParams
}

const mutations = {
  [types.SOCKET_LIST] (state, data) {
    state.imConfig = data.data || {}
    state.msgUrl = `https://${data.data.domain}`
    const prefix = window.location.protocol === 'http:' ? 'wss://' : 'wss://'
    const suffix = window.location.host === 'ldl.eduzhixin.com' ? ':' + data.data.wss_port : ''
    state.imConfig.wsUrl = prefix + data.data.nodes[0] + suffix + '/sub'
    // this.commit(types.START_SOCKET)
  },
  [types.START_SOCKET] (state) {
    window.WsClient = new Client(state.imConfig)
  },
  [types.WS_STATUS] (state, data) {
    state.wsStatue = data
  },
  [types.WS_LOADING] (state, data) {
    state.wsLoading = data
  },
  [types.WS_MESSAGE] (state, { data, userId }) {
    const wsMsg = JSON.parse(data)
    if (wsMsg.MessageType === 19) {
      state.newTips = wsMsg
      return false
    }
    if (wsMsg.MessageType === 21 && router.app._route.name === 'live' && !state.hasTips) {
      state.hasTips = true
      window.location.href = '/'
      Vue.prototype.$msgDialog('您的账号已在其他设备或浏览器进入直播间，已退出！', () => {
        state.hasTips = false
      })
      return false
    }
    if (wsMsg.MessageType === 22) {
      state.removeMessageKey = wsMsg.MessageKey
      return false
    }
    if (Number(userId) === Number(wsMsg.UserId)) return false
    state.chatMessage = wsMsg
  },
  [types.GIFT_MESSAGE] (state, data) {
    state.giftMessage = data
  },
  [types.SOCKET_LIVE_AD] (state, data) {
    state.socketLiveAd = data
  },
  [types.PROTON_AWARDS_MSG] (state, data) {
    state.protonAwardsMsg = Object.assign({}, data)
  },
  [types.CLEAR_NEW_TIPS] (state, data) {
    state.newTips = data
  },
  [types.CLEAR_MESSAGE_KEY] (state, data) {
    state.removeMessageKey = data
  },
  [types.CLEAR_CHAT_MESSAGE] (state, data) {
    state.chatMessage = data
  },
  [types.CLEAR_GIFT_MESSAGE] (state, data) {
    state.giftMessage = data
  },
  [types.UPDATE_FABULOUS] (state, data) {
    state.fabulous = data
  },
  [types.UPDATE_APPLAUSE] (state, data) {
    state.applause = data
  },
  [types.UPDATE_HAS_TIPS] (state, data) {
    state.hasTips = data
  },
  [types.QUESTION_PARAMS] (state, data) {
    state.questionParams = data
  },
  [types.WS_CONNECTED_STATUS] (state, data) {
    state.wsConnectStatus = data
  }
}

const actions = {
  getSocketList ({ commit }) {
    api.getSocketList({ platform: 'web', msgUrl: true }).then(res => {
      commit(types.SOCKET_LIST, res.data || {})
    }, _ => {
      commit(types.SOCKET_LIST, {})
    })
  },
  updateWsStatus ({ commit }, flag) {
    commit(types.WS_STATUS, flag)
  },
  updateWsLoading ({ commit }, flag) {
    commit(types.WS_LOADING, flag)
  },
  handleSocketChat ({ commit, getters }, data) {
    commit(types.WS_MESSAGE, { data, userId: getters.userInfo.user_id })
  },
  handleSocketGift ({ commit }, data) {
    commit(types.GIFT_MESSAGE, data)
  },
  handleSocketLiveAd ({ commit }, data) {
    commit(types.SOCKET_LIVE_AD, data)
  },
  handleProtonAwardsMsg ({ commit }, data) {
    commit(types.PROTON_AWARDS_MSG, data)
  },
  clearNewTips ({ commit }) {
    commit(types.CLEAR_NEW_TIPS, {})
  },
  clearMessageKey ({ commit }) {
    commit(types.CLEAR_MESSAGE_KEY, '')
  },
  clearChatMessage ({ commit }) {
    commit(types.CLEAR_CHAT_MESSAGE, {})
  },
  clearGiftMessage ({ commit }) {
    commit(types.CLEAR_GIFT_MESSAGE, {})
  },
  clearSocketLiveAd ({ commit }) {
    commit(types.SOCKET_LIVE_AD, {})
  },
  updateFabulous ({ commit }, data) {
    commit(types.UPDATE_FABULOUS, data)
  },
  updateApplause ({ commit }, data) {
    commit(types.UPDATE_APPLAUSE, data)
  },
  updateHasTips ({ commit }, data) {
    commit(types.UPDATE_HAS_TIPS, data)
  },
  startSocket ({ commit }) {
    commit(types.START_SOCKET)
  },
  updateQuestionParams ({ commit }, data) {
    commit(types.QUESTION_PARAMS, data)
  },
  updateWsConnectStatus ({ commit }, data) {
    commit(types.WS_CONNECTED_STATUS, data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
